import React, { memo, useEffect } from 'react';

import { Button, Switch, Typography } from 'antd';

import { Field, useFormikContext } from 'formik';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IAffiliate } from 'v2/interfaces/affiliate';

import type { IFormCommision } from '../interfaces';

interface IProps {
  handleClose: (...args: any[]) => any;
  affiliate: IAffiliate;
}

const FormCommision = ({ handleClose, affiliate }: IProps) => {
  const { values, setFieldValue, isSubmitting, isValid } = useFormikContext<IFormCommision>();

  const onChangeActive = (checked: boolean) => {
    setFieldValue('active', checked);
  };

  const onChangeType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('type', e.target.value);
    setFieldValue('value', '');
  };

  const typeOptions = [
    { label: 'Porcentagem', value: 'P' },
    { label: 'Valor', value: 'V' }
  ];

  useEffect(() => {
    if (affiliate.custom_commission_type && affiliate.custom_commission) {
      setFieldValue('active', true);
    }

    if (affiliate.custom_commission_type) {
      setFieldValue('type', affiliate.custom_commission_type);
    }

    if (affiliate.custom_commission) {
      setFieldValue('value', affiliate.custom_commission);
    }
  }, [affiliate, setFieldValue]);

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-center gap-2'>
        <Switch checked={values.active} disabled={isSubmitting} onChange={onChangeActive} />
        <Typography.Text>Habilitar comissão diferenciada</Typography.Text>
      </div>

      <div className='grid grid-cols-1 gap-4 md:grid-cols-12'>
        <div className='md:col-span-7'>
          <Field
            id='type'
            name='type'
            label='Tipo da comissão'
            fullWidth
            disabled={true}
            options={typeOptions}
            component={SelectFormField}
            onChange={onChangeType}
          />
        </div>

        <div className='md:col-span-5'>
          {values.type === 'P' && (
            <Field
              id='value'
              disabled={!values.active}
              name='value'
              label='Porcentagem'
              mask='percent'
              fullWidth
              component={TextFormField}
            />
          )}

          {values.type === 'V' && (
            <Field
              id='value'
              disabled={!values.active}
              name='value'
              mask='money'
              label='Valor'
              fullWidth
              component={TextFormField}
            />
          )}
        </div>
      </div>

      <div className='flex flex-wrap items-center justify-end gap-2'>
        <Button type='text' disabled={isSubmitting} onClick={() => handleClose()}>
          Fechar
        </Button>
        <Button type='primary' disabled={isSubmitting || !isValid} htmlType='submit' loading={isSubmitting}>
          Salvar
        </Button>
      </div>
    </div>
  );
};

export default memo(FormCommision);
